const $$splitComponentImporter = () => import('/app/frontend/src/routes/_auth/deactivated.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { routeForState } from '@/features/auth/model/state-route';
export const Route = createFileRoute('/_auth/deactivated')({
  staticData: {
    backgroundImage: '/login_background.jpg'
  },
  beforeLoad: async ({
    context
  }) => {
    const {
      frontendUserState
    } = await context.ensureProfile();
    if (routeForState(frontendUserState) !== '/deactivated') {
      throw redirect({
        to: '/'
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});